<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';

const props = defineProps({
  // @ts-expect-error weird vue-router@3 typing
  ...RouterLink.props,
  to: {
    type: [String, Object],
    default: undefined
  },
  target: {
    type: String,
    default: '_self'
  }
});

const internalHref = computed(() => {
  if (!props.to) {
    return '';
  }

  if (typeof props.to === 'string') {
    return props.to;
  }

  const { path, query, hash } = props.to;

  const toRecordJoined = (input: Record<string, string | string[]>, separator = ',') => {
    return Object.keys(input).reduce<Record<string, string>>((acc, key) => {
      const val = input[key];
      acc[key] = Array.isArray(val) ? val.join(separator) : val;
      return acc;
    }, {});
  };

  const searchParams = new URLSearchParams(toRecordJoined(query));

  return new URL(`${path}?${searchParams.toString()}${hash}`).toString();
});

defineEmits(['click']);
</script>

<template>
  <a
    v-if="props.to && props.target !== '_self'"
    :href="internalHref"
    :target="props.target"
    @click="$emit('click')"
  >
    <slot />
  </a>
  <router-link v-else-if="props.to" v-slot="{ navigate, href }" v-bind="{ ...props, custom: true }">
    <a
      :href="href"
      @click="
        event => {
          $emit('click', event);
          navigate(event);
        }
      "
    >
      <slot />
    </a>
  </router-link>
</template>

<style scoped lang="scss">

</style>
